module.exports = __webpack_public_path__ + "img/logo.31379829.png";